<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-table-search-with-select">
    <table>
      <tr>
        <td style="display: flex; position: relative;" class="div-search-input">
          <i class="el-icon-search" ></i>
          <div class="divider"></div>
          <el-input ref="searchBarInput" placeholder="Search AI tags or categories" v-model="keyword" class="input-with-select"
            @keyup.native="handleKeypress" @change="inputChange" @keypress.enter.native="handleSearch">
            <el-select v-if="searchFields" popper-class="wy-seardh-bar-select" v-model="dataModel.fieldName" @change="handleSearchFieldsChange"
              slot="prepend">
              <el-option v-for="field in searchFields" :label="field.label" :value="field.name"
                :key="field.name" :data-testid="dataTestIdSearchType?(dataTestIdSearchType+'-'+formatTestId(field.name)):undefined"></el-option>
            </el-select>
            <!-- <el-select v-model="select" slot="prepend" placeholder="Select">
              <el-option label="Restaurant" value="1"></el-option>
              <el-option label="Order No." value="2"></el-option>
              <el-option label="Tel" value="3"></el-option>
            </el-select> -->
          </el-input>
          <i class="fas fa-times-circle" v-if="keyword != ''" @click="clearKeywordSearch"></i>
        </td>
        <td>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WyUtils from '../../library/wy-utils.js';

export default {
  name: 'wy-table-search-with-select',
  props: ['searchFields', 'controller', 'callback', 'dataTestIdSearchType'],

  data() {
    return {
      selectTabWidth: 0,
      keyword: '',
      searchTimeout: null,
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel']),
  },

  methods: {
    formatTestId(str) {
      return WyUtils.toUpperCaseFirstLetter(str);
    },
    isInputActive() {
      return this.dataModel.keyword != "";
    },

    handleSearchFieldsChange() {
      this.controller.searchFields = this.dataModel.fieldName;
    },

    handleSearch() {
      this.dataModel.keyword = this.keyword ? this.keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').toLowerCase() : '';
      if (this.callback) this.callback({ pageNumber: 1 });
      this.hightLightKeywords()
    },
    clearKeywordSearch() {
      this.keyword = '';
      this.handleSearch();
    },

    traversalDomElements(regEx, el) {
      el.innerHTML = el.innerText.replace(regEx, "<span class='highlight-keywords'>$&</span>");
    },

    hightLightKeywords() {
      let search = this.dataModel.keyword;
      search = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').toLowerCase()
      const regEx = new RegExp(search, 'gi');
      setTimeout(() => {
        const elList = document.querySelectorAll(`.wy-table-list [col="`+ this.dataModel.fieldName +`"] span.wy-table-content`)//document.querySelectorAll(`.wy-table-list span.wy-table-content`);
        for(const el of elList) {
          this.traversalDomElements(regEx, el);
        }
      }, 100);
    },

    handleIconClick() {
      if (this.isInputActive()) {
        this.dataModel.keyword = '';
        this.$refs.searchBarInput.$el.classList.remove('active');
      }
      this.handleSearch();
    },

    handleKeypress() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(() => {
        this.dataModel.keyword = this.keyword ? this.keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').toLowerCase() : '';
        if (this.isInputActive()) {
          this.$refs.searchBarInput.$el.classList.add('active');
        }
        else {
          this.$refs.searchBarInput.$el.classList.remove('active');
        }
        this.hightLightKeywords()
      }, 150);

    },

    inputChange() {
      if (this.keyword == '') {
        this.dataModel.keyword = this.keyword;
      }
    }
  },

  created() {
    this.keyword = '';
    if (this.dataModel.fieldName === null && this.searchFields) {
      // get the default selected field
      let selectedField = this.searchFields[0];
      this.dataModel.fieldName = selectedField.name;
    }

    if (this.searchFields) {
      // get the dropdown item with longest text and calculate the with of the text
      let largestItem = this.searchFields.reduce((a, b) => a.label.length > b.label.length ? a : b);
      this.selectTabWidth = (WyUtils.calcTextWidth(largestItem.label, 14) + 55) + 'px';
    }
  },

  mounted() {
    this.keyword = this.dataModel.keyword;
    this.clearKeywordSearch();
  }
  ,
  beforeDestroy() {
    this.dataModel.keyword = '';
  }
}
</script>

<style lang="scss">
.wy-table-search-with-select {

  .el-select .el-input {
    width: 185px;
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
    border-right: 0px !important;
    .el-input__inner {
      padding-left: 50px;
      border-bottom-right-radius: 0px;
      border-top-right-radius: 0px;
      border-right: 0px !important;
    }
   
    .el-input__inner:focus {
      border: 0px;
    }
  }
  input.el-input__inner {
    border: 0px !important;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
    color: #4A4A4F;
  }

  .input-with-select > .el-input__inner {
    border-radius: 7px;
    padding-left: 10px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
    width: 400px;
  }
  // .input-with-select {
  //   border-right: 1px !important;
  // }
  div.el-input,
  .el-input-group {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #D7D7D8;
    border-left: 0px;
    border-radius: 4px;
    // opacity: 1;
    width: 275px;
    // margin-left: -3px;
    // padding-left: 12px;
    // height: 33px;
    // display: flex;
    // padding-right: 50px;
    // align-items: center;

    &:hover {
      // background: #F3F6F8 0% 0% no-repeat padding-box;
    }

    &:focus-within {
      // border: 1px solid #106FBC;
      // background: #FFFFFF 0% 0% no-repeat padding-box;
    }
  }

  .el-icon-search {
    // background-image: url('../../assets/icons/icon_search.svg');
    // background-repeat: no-repeat;
    // background-size: 20px 28px;
    // background-position-y: 1px;
    // background-position-x: 5px;
    position: absolute;
    left: 10px;
    top: 13px;
    z-index: 1;
    // color: #B3B3B3 !important;
  }
  .divider {
    position: absolute;
    left: 186px;
    top: 20%;
    bottom: 20%;
    border-left: 1px solid #D7D7D8;
    z-index: 1;
  }

  .el-input__suffix {
    // background-image: url('../../assets/icons/icon_close.svg');
    // background-repeat: no-repeat;
    // background-position-y: 6px;
  }

  .el-icon-circle-close:before {
    content: "";
  }

  input {
    // border: none;
    // padding-left: none !important;
    // height: 30px !important;
    // color: var(--site-font-primary-color);
    // background-color: transparent !important;
    // padding-left: 0px;
    &:hover {
      // background: #F3F6F8;
    }

    &:focus-within {
      background: transparent;
    }
  }

  input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #4B5158;
    opacity: 1;
    /* Firefox */
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #4B5158;
  }

  input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #4B5158;
  }

  .el-input-group__append {
    border: none;
    background-color: #fff;
    border-left: 1px solid #D7D7D8 !important;
  }

  .el-input__icon {
    line-height: 32px;
  }

  .el-input__icon.el-icon-click {
    background-image: url('../../assets/icons/icon_search.svg');
    background-repeat: no-repeat;
    background-size: 20px 28px;
    background-position-y: 1px;
    background-position-x: 5px;
  }

  .el-input__icon.el-icon-click:hover {
    cursor: pointer;
  }

  .el-input__icon.el-icon-click::before {
    content: ''
  }

  .el-input__icon.el-icon-click {
    content: ''
  }

  .el-select {
    .el-input__inner {
      color: #B3B3B3;
    }
  }

  // .el-select__caret {
  //   background-image: url('../../assets/icons/icon_dropdown_down.svg');
  //   background-repeat: no-repeat;
  //   background-size: 12px 9px;
  //   background-position-y: 16px;
  //   background-position-x: 3px;
  //   transform: none;
  // }

  // .el-select__caret::before {
  //   content: ''
  // }

  // .el-select__caret::after {
  //   content: ''
  // }

  .fa-times-circle {
    position: relative;
    left: -28px;
    bottom: 0px;
    top: 12px;
    float: right;
    color: #5C5F62 !important;
    font-size: 20px;
    cursor: pointer;
  }
}

.el-input-group.active {
  .el-input__inner {
    color: var(--site-font-primary-color);
  }

  .el-select__caret {
    background-image: unset !important;
  }

  .el-input__icon.el-icon-click {
    background-image: url('../../assets/icons/icon_delete.svg') !important;
  }
}

.wy-seardh-bar-select {
  .el-select-dropdown__item.selected {
    color: var(--site-font-primary-color) !important;
  }
}
</style>
